import { Progress, Tooltip } from "@mantine/core";
import overallAttempt from "../../../../../assets/img/Images/overallAttempt.svg"
import accuracy from "../../../../../assets/img/Images/accuracy.svg"
import score from "../../../../../assets/img/Images/score.svg"
import time from "../../../../../assets/img/Images/time.svg"
import { useDetails } from "../../DetailsContext";
import { useState } from "react";
export default function Subjects({temp}) {
  //  console.log(temp,"here33")
  const { details, setDetails } = useDetails();
  const scrollToTop = () => {
    setDetails(!details)
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      style={{
        transition: "3s all ease",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: "1rem",
        marginBottom: "1rem",
        "border-radius": "30px",
      }}
    >
      <p
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          margin: "auto",
          zIndex: "0",
          paddingLeft: "5.5%",
        }}
      >
        {temp?.section}
      </p>
      <div style={{ display: "flex", justifyContent: "center",alignItems:"center" }}>
      
         <div
        style={{
          display: "flex",
          width: "80%",
          margin: "auto",
          height: "1.5rem",
          borderRadius: "2rem",
          zIndex: "0",
          // marginTop: "2rem",
          justifyContent: "center",
          // alignItems:"center",
          
        }}
        onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      >
          <Tooltip label={`${temp.correct} Correct`}  arrowOffset={1} arrowSize={8} withArrow opened={isHovered} >
        <div
          style={{
            width: "20%",
            backgroundColor: "#FE7970",
            borderTopLeftRadius: "2rem",
            borderBottomLeftRadius: "2rem",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              "background-color": "#3CB371",
              borderTopLeftRadius: "2rem",
              borderBottomLeftRadius: "2rem",
              borderTopRightRadius: "2rem",
              borderBottomRightRadius: "2rem",
            }}
          >
            &nbsp;
          </div>
        </div>
        </Tooltip>
        <Tooltip label= {`${temp.wrong} Incorrect`} arrowOffset={1} arrowSize={8} withArrow opened={isHovered}>
        <div style={{ backgroundColor: "#C0C0C0", width: "40%" }}>
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "#FE7970",
              borderTopRightRadius: "2rem",
              borderBottomRightRadius: "2rem",
            }}
          >
            &nbsp;
          </div>
        </div>
        </Tooltip>
        <Tooltip label= {`${temp.skipped} Skipped`} arrowOffset={1} arrowSize={8} withArrow opened={isHovered}>
        <div
          style={{
            backgroundColor: "#C0C0C0",
            width: "40%",
            borderTopRightRadius: "2rem",
            borderBottomRightRadius: "2rem",
          }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: "#C0C0C0",
              display: "flex",
              alignItems: "center",
            }}
          ></div>
        </div>
        </Tooltip>
      </div>
     
        <button
          style={{
            backgroundColor: "#004AAD",
            "border-radius": "0.5rem",
            "padding-left": "0.5rem",
            "padding-right": "0.5rem",
            "font-size": "1rem",
            color: "white",
            width: "6rem",
            height: "3rem",
            marginRight: "3rem",
            cursor:"pointer"
          }}
          onClick={scrollToTop}
        >
          Details
        </button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          "font-size": "1.25rem",
          width: "70%",
          marginLeft: "6rem",
          marginRight: "auto",
          "font-style": "Montessori",
        }}
      >
        <p style={{display:"flex",alignItems:"center",columnGap:"0.3rem"}}><img src={overallAttempt} alt="" />overall attempt-{temp?.correct+temp?.wrong}</p>
        <p style={{display:"flex",alignItems:"center",columnGap:"0.3rem"}}><img src={accuracy} alt="" />Accuracy-20</p>
        <p style={{display:"flex",alignItems:"center",columnGap:"0.3rem"}}><img src={score} alt="" />Score-20</p>
        <p style={{display:"flex",alignItems:"center",columnGap:"0.3rem"}}><img src={time} alt="" />Time-20</p>
        
      </div>
    </div>
  );
}
